/**
 * Common Encryption scheme.
 *
 * @group DRM
 *
 * @beta
 */
export const CENC = 'cenc';
